// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bcc_a bhf_a bhf_r bhf_j","ModeratorInvitationListItem__left":"bcc_b bhf_a bhf_j","ModeratorInvitationListItem__note":"bcc_c bhf_fm"};